"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReactNative = isReactNative;

/**
 * A helper used to detect if we're running in a React Native environment. Useful For
 * universal (shared) platform code.
 */
function isReactNative() {
  if (typeof navigator !== "undefined" && navigator.product === "ReactNative") {
    return true;
  } else {
    return false;
  }
}
//# sourceMappingURL=isReactNative.js.map